import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "../common/SectionHeading";
import ProjectCard from "../projects/ProjectCard";
import projects from "../../data/projects";
import "./SelectedWorks.css";

/**
 * Layout recipe for the works grid, on a 12-column field.
 *
 * Hard-coding the composition rather than letting `auto-fit` decide is the
 * point of this section: a uniform grid of equal tiles reads as a catalogue,
 * while alternating 7/5 column splits with a vertical offset on the narrower
 * tile reads as a portfolio. Each entry also picks an aspect ratio that suits
 * its column width, so no photograph is cropped into an awkward shape.
 *
 * @type {{ columnSpan: number, ratioClass: string, isOffset: boolean }[]}
 */
const WORKS_LAYOUT = [
  { columnSpan: 7, ratioClass: "frame--wide", isOffset: false },
  { columnSpan: 5, ratioClass: "frame--tall", isOffset: true },
  { columnSpan: 5, ratioClass: "frame--tall", isOffset: false },
  { columnSpan: 7, ratioClass: "frame--landscape", isOffset: true },
  { columnSpan: 6, ratioClass: "frame--wide", isOffset: false },
  { columnSpan: 6, ratioClass: "frame--wide", isOffset: false },
];

/**
 * Selected works for the home page.
 *
 * The first project in the archive is skipped: it already has the full-bleed
 * feature section above, and repeating it here would weaken both.
 *
 * @returns {JSX.Element}
 */
function SelectedWorks() {
  const worksToShow = projects.slice(1, 1 + WORKS_LAYOUT.length);

  return (
    <section className="works section" id="projekti">
      <div className="shell">
        <SectionHeading
          index="03"
          eyebrow="Projekti"
          headlineLines={["Odabrani radovi."]}
          aside={`${String(projects.length).padStart(2, "0")} u arhivi`}
        />

        <div className="works__grid">
          {worksToShow.map((project, projectIndex) => {
            const layout = WORKS_LAYOUT[projectIndex];

            return (
              <div
                className="works__cell"
                key={project.id}
                data-offset={layout.isOffset ? "true" : "false"}
                style={{ "--column-span": layout.columnSpan }}
              >
                <ProjectCard
                  project={project}
                  ratioClass={layout.ratioClass}
                  ordinal={String(projectIndex + 2).padStart(2, "0")}
                  sizes={
                    layout.columnSpan >= 7
                      ? "(min-width: 64rem) 58vw, 100vw"
                      : "(min-width: 64rem) 40vw, 100vw"
                  }
                />
              </div>
            );
          })}
        </div>

        <div className="works__footer" data-reveal="rise-sm">
          <Link className="rule-link" to="/projekti">
            <span>Svi projekti</span>
            <span className="rule-link__arrow" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SelectedWorks;
